import React from "react";
import reasons from "venuescanner-js/constants/decline-reasons.js";
import userTypes from "venuescanner-js/constants/user_type";
import { isActionFromViewer } from "./isActionFromViewer";

export function ClosedViewedByOrganiser({ message, viewerRole, thread }) {
  const didOrganiserClose = isActionFromViewer(message, viewerRole);

  return didOrganiserClose ? (
    "You have cancelled the enquiry"
  ) : (
    <>
      The venue has cancelled your enquiry. Still looking for a venue for your
      event? You can see similar venues{" "}
      <a href={`/book-venue-${thread._space.url.split("/")[1]}`}>here</a>
    </>
  );
}

export function ClosedViewedByHost({ message, viewerRole, thread }) {
  const didHostClose = isActionFromViewer(message, viewerRole);

  return didHostClose
    ? "You have cancelled the enquiry"
    : `The organiser has cancelled this enquiry for the following reason: ${whyDeclined(
        { thread, message }
      )}`;
}

const declineReason = {
  [userTypes.host]: {
    [reasons.ANOTHERVENUE]: "They found another venue.",
    [reasons.AVAILABILITY]: "Venue not available.",
    [reasons.EXPIRED]: "Event date has passed.",
    [reasons.NOREPLY]: "No response.",
    [reasons.OTHER]: "None provided.",
    [reasons.PRICE]: "Budget not suitable.",
    [reasons.SUITABILITY]: "Venue not suitable.",
    [reasons.TERMS]: "Could not agree on terms.",
  },
  [userTypes.organiser]: {
    [reasons.ANOTHERVENUE]: "You found another venue.",
    [reasons.AVAILABILITY]: "Venue not available.",
    [reasons.EXPIRED]: "Event date has passed.",
    [reasons.OTHER]: "None provided.",
    [reasons.NOREPLY]: "No response.",
    [reasons.PRICE]: "Budget not suitable.",
    [reasons.SUITABILITY]: "Venue not suitable.",
    [reasons.TERMS]: "Could not agree on terms.",
  },
};

function whyDeclined({ thread, message }) {
  return message.offer &&
    message.offer.reason &&
    declineReason[thread.viewerRole] &&
    declineReason[thread.viewerRole][message.offer.reason]
    ? declineReason[thread.viewerRole] &&
        declineReason[thread.viewerRole][message.offer.reason]
    : message.offer && message.offer.reason
    ? message.offer && message.offer.reason
    : "None provided.";
}
